import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { selectedLanguage } from "../../store/slices/selectedLanguageSlice";
import translations from "../../language.json";

import "swiper/css";
import "swiper/css/effect-cards";

const Showcase = () => {
  const selectedLanguages = useSelector(selectedLanguage);

  return (
    <section className="showcase">
      <div className="showcase__container container">
        <h2>{translations[selectedLanguages].showcase.title}</h2>
        <p>{translations[selectedLanguages].showcase.context}</p>
        <div className="showcase__pagination">
          <NavLink to="/templates/websites" end>
            <svg version="1.0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 526.000000 474.000000" preserveAspectRatio="xMidYMid meet">
              <g transform="translate(0.000000,474.000000) scale(0.100000,-0.100000)" stroke="none">
                <path
                  d="M499 4486 c-102 -27 -181 -95 -228 -196 l-26 -55 -3 -1414 c-2 -1253
-1 -1421 13 -1475 26 -102 91 -181 185 -225 l55 -26 813 -3 812 -2 -2 -173 -3
-172 -202 -5 c-184 -5 -204 -7 -229 -26 -46 -34 -67 -70 -72 -123 -6 -68 29
-130 91 -160 43 -21 50 -21 929 -21 l885 0 43 23 c111 58 119 205 16 281 -25
19 -45 21 -229 26 l-202 5 -3 172 -2 173 812 2 813 3 55 27 c97 48 159 123
185 224 14 54 15 222 13 1475 l-3 1414 -28 61 c-35 76 -94 135 -172 171 l-60
28 -2105 2 c-1647 1 -2115 -1 -2151 -11z m4121 -341 c65 -33 60 71 60 -1361
l0 -1302 -29 -31 -29 -31 -1982 0 c-1439 0 -1987 3 -2003 11 -12 6 -30 21 -39
33 -16 20 -18 104 -18 1319 0 899 3 1304 11 1318 5 11 25 29 42 39 31 20 69
20 1995 20 1722 0 1967 -2 1992 -15z"
                />
              </g>
            </svg>
            {translations[selectedLanguages]?.templatesMain?.websites}
          </NavLink>
          <NavLink to="/templates/invitations">
            <svg version="1.0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 389.000000 641.000000" preserveAspectRatio="xMidYMid meet">
              <g transform="translate(0.000000,641.000000) scale(0.100000,-0.100000)" stroke="none">
                <path
                  d="M712 6339 c-244 -36 -451 -209 -545 -455 l-22 -59 -3 -2583 c-3
-2885 -9 -2643 70 -2796 82 -158 233 -280 418 -338 l75 -23 1240 0 c1391 0
1287 -5 1451 75 148 72 278 220 336 380 l23 65 3 2583 c2 2885 9 2643 -70
2796 -82 158 -235 281 -418 338 l-75 23 -1210 1 c-688 1 -1237 -2 -1273 -7z
m1770 -406 c24 -22 23 -66 -3 -89 -20 -18 -44 -19 -529 -19 -485 0 -509 1
-529 19 -25 23 -27 63 -4 88 15 17 45 18 531 18 466 0 517 -2 534 -17z m985
-666 l28 -27 3 -2001 c2 -2215 7 -2052 -61 -2080 -26 -11 -308 -13 -1492 -14
-1356 0 -1462 2 -1491 17 -19 10 -36 31 -43 49 -16 46 -16 3973 0 4018 7 18
26 41 43 52 30 19 70 19 1508 17 l1478 -3 27 -28z m-1391 -4362 c71 -31 128
-86 161 -153 23 -48 28 -70 28 -137 0 -67 -5 -89 -28 -137 -94 -191 -336 -241
-494 -103 -90 79 -129 195 -103 306 46 201 251 306 436 224z"
                />
              </g>
            </svg>
            {translations[selectedLanguages]?.templatesMain?.invitations}
          </NavLink>
        </div>
      </div>
    </section>
  );
};

export default Showcase;
